import {DrawerProps} from '@mantine/core';
import {FormDrawer} from './FormDrawer.tsx';
import {usePersona} from '../hooks/usePersona.ts';
import {buildInitialValues} from '../forms/buildInitialValues.ts';

export const AddFormDrawer = (props: DrawerProps) => {

    const {createRecord} = usePersona();

    return (
        <FormDrawer
            record={buildInitialValues()}
            handleSubmit={createRecord}
            {...props}
        />
    );
};
